
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.505.205a.7.7 0 01.99 0l2.1 2.1a.7.7 0 01-.99.99L7.7 2.39V4.9h5.6a.7.7 0 110 1.4H.7a.7.7 0 110-1.4h5.6V2.39l-.905.905a.7.7 0 11-.99-.99l2.1-2.1zM0 8.4a.7.7 0 01.7-.7h12.6a.7.7 0 110 1.4H7.7v2.51l.905-.905a.7.7 0 01.99.99l-2.1 2.1a.7.7 0 01-.99 0l-2.1-2.1a.7.7 0 01.99-.99l.905.905V9.1H.7a.7.7 0 01-.7-.7z","fill":"#2B3E8A"}})])
          )
        }
      }
    